// @flow
import React from 'react'

const LoadError = (): any => <div className='login'>
  <div className='login__header'>
    <i className='icon icon--logo' />
    <h3>Failed to load page</h3>
  </div>
  <h4>A report has been sent to the Winmore team. If this issue persists, please contact us at <a href='mailto:support@lanetix.com'>support@lanetix.com</a> or reach out through Help & Feedback in the main menu.</h4>
</div>

export default LoadError
